import React from 'react';
import { Card } from 'react-bootstrap';

function DashboardStatCard({ label, value, icon, iconBg, iconColor, subtext, accentColor = '#3B82F6' }) {
    return (
        <Card className="border-0 shadow-sm dashboard-stat-card h-100">
            <Card.Body>
                <div className="d-flex align-items-start justify-content-between gap-2">
                    <div className="flex-grow-1 min-w-0">
                        <div className="text-secondary small mb-1">{label}</div>
                        <h4 className="mb-0 fw-bold text-truncate">{value}</h4>
                        {subtext && <div className="text-secondary small mt-1">{subtext}</div>}
                    </div>
                    <div
                        className="dashboard-stat-card__icon"
                        style={{ backgroundColor: iconBg, color: iconColor }}
                    >
                        <i className={icon}></i>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}

export default DashboardStatCard;

/** Bearer token used by dashboard + admin helpers */
export function getAdminDashboardToken(userState) {
    const nested = userState?.user || userState;
    return nested?.token || localStorage.getItem('adminToken') || '';
}
